import { CircularProgress, List, ListItemButton, Paper, TextField, Typography } from "@mui/material"
import RequiredLabel from "../../pages/UtilityComponent/RequiredLabel"
import { ErrorMessage } from "formik";
import { getBusinessUnit, searchMoreAddressOnScroll } from "../../store/APISlice";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch } from "../../store/store";
import { AddressOption } from "../../pages/ShippingInformationComponent/ShippingInformation";
import axios from "axios";
import { useSelector } from "react-redux";

interface SearchSelect {
    labelName: string,
    value: string,
    onValueChange: Function,
    placeHolder: string,
    onSelect: Function
}

const SearchSelectComponent = ({ labelName, value, onValueChange, placeHolder, onSelect }: SearchSelect) => {


    const dispatch = useAppDispatch();

    const [loading, setLoading] = useState(false);

    const [addressLoading, setAddressLoading] = useState(false);

    const listRef = useRef(null);

    const [pageNo, setPageNo] = useState(0);

    const [hasMore, setHasMore] = useState(true);

    const isPageUpdating = useRef(false);

    const [addressOptions, setAddressOptions] = useState<AddressOption[]>([]);

    const debounceTimeout = useRef<any>(null);

    const [showList, setShowList] = useState(false);

    const abortControllerRef: any = useRef(null);

    const selectedBu = useSelector(getBusinessUnit);


    useEffect(() => {
        if (pageNo > 0) {
            loadMoreRecords(value);
        }
    }, [pageNo, isPageUpdating])

    const loadInitialAddresses = (value: any) => {
        if (abortControllerRef && abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const newAbort = new AbortController();
        abortControllerRef.current = newAbort;

        setLoading(true);
        setPageNo(0);
        const payload = {
            reqBody: {
                streetAddress: value,
                businessUnit: selectedBu,
                page: 0,
                size: 50,
                isCancel: true
            },
            abortObj: newAbort
        }
        dispatch(searchMoreAddressOnScroll(payload)).then((res: any) => {
            if (res.payload.status === 200) {
                setAddressOptions(res?.payload?.data?.content as AddressOption[]);
                setShowList(true);
                setHasMore(pageNo < res?.payload?.data?.totalPages);
            }
            setLoading(false);
        }).catch((err: any) => {
            console.error('Error fetching address options:', err);
            setLoading(false);
        })
    }


    const handleScroll = (event: any) => {

        if (isPageUpdating.current || addressLoading || !hasMore) return;

        const { scrollTop, scrollHeight, clientHeight } = event.target;

        const scrollPosition = scrollTop + clientHeight;

        const scrollCheck = getScrollValByPage(pageNo);

        if (scrollPosition >= scrollHeight * scrollCheck) {
            setPageNo((prev) => prev + 1);
            isPageUpdating.current = true;
        }
    }

    const getScrollValByPage = (page: number) => {
        if (page === 1) return 0.6;
        if (page === 2) return 0.65;
        return Math.min(0.6 + page * 0.05, 0.85);
    }

    const loadMoreRecords = (inputVal: any) => {
        setAddressLoading(true);
        const newAbort = new AbortController();
        abortControllerRef.current = newAbort;
        const payload = {
            reqBody: {
                streetAddress: inputVal,
                businessUnit: selectedBu,
                page: pageNo,
                size: 50,
                isCancel: true
            },
            abortObj: newAbort
        }
        dispatch(searchMoreAddressOnScroll(payload)).then((res: any) => {
            if (res.payload.status === 200) {
                setAddressOptions(prevItems => [...prevItems, ...res?.payload?.data?.content]);
                setShowList(true);
                setHasMore(res?.payload?.data?.content?.length > 0);
            }
            setAddressLoading(false);
            isPageUpdating.current = false;
        }).catch((err: any) => {
            console.error('Error fetching address options:', err);
            isPageUpdating.current = false;
            setAddressLoading(false);
        })
    }

    const handleFormValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        const { name, value } = event.target;

        onValueChange(name, value);

        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
        debounceTimeout.current = setTimeout(() => {
            if (value.length > 2) {
                loadInitialAddresses(value);
            }
        }, 1000)
    }

    const handleOptionSelect = (option: any) => {
        setShowList(false);
        onSelect(option);
    }

    const handleFocus = () => {
        setShowList(true);
    }


    return (

        <div style={{ position: 'relative' }}>
            <RequiredLabel label="Street Address" mandatory={true} />
            <TextField id={labelName} name={labelName} type={"text"} variant="outlined" size="small"
                fullWidth margin="dense" InputProps={{
                    style: {
                        fontSize: '0.8rem'
                    }
                }} autoComplete="off" value={value} placeholder={placeHolder} onChange={handleFormValueChange} onFocus={handleFocus} />
            <ErrorMessage name={labelName} component="div" className="error-message" />
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', height: '10px' }}>
                {loading && <CircularProgress size={24} />}
            </div>
            {showList && addressOptions?.length > 0 && (
                <Paper elevation={3} style={{ position: 'absolute', zIndex: 1 }}>
                    <div ref={listRef} onScroll={handleScroll} style={{ maxHeight: "300px", overflowY: "auto", border: '1px solid #ccc', scrollbarWidth: 'thin' }}>
                        <List>
                            {addressOptions.map((option, index) => (
                                <ListItemButton key={index} sx={{
                                    "&.Mui-selected": { backgroundColor: '#e0e0e0' },
                                    '&:hover': { backgroundColor: '#e0e0e0' },
                                    cursor: 'pointer'
                                }} onClick={() => handleOptionSelect(option)} >
                                    <Typography sx={{ font: 'normal normal 12px Segoe UI' }}>
                                        {option.locationID} - {option.locationName} - {option.streetAddress} -  {option.city} -  {option.zipCode}
                                    </Typography>
                                </ListItemButton>
                            ))}
                            {addressLoading && (
                                <CircularProgress size={20} style={{ margin: '10px auto', display: 'block' }} />
                            )}
                        </List>
                    </div>
                </Paper>
            )}
        </div>

    )

}

export default SearchSelectComponent;